import produce from "immer";
import { IStoreState } from "../initialStoreState";

import { GenAiActions } from ".";
import { LoadState } from "../../constants/enums";
import {
  defaultGenAiPrompt,
  defaultGenAiContext,
  defaultGenAiState,
} from "./deafaultState";
import {
  CLEAR_GENAI_PROMPT,
  CLEAR_GENAI_PROMPT_STATE,
  FETCH_GENAI_PROMPT_FAILED,
  FETCH_GENAI_PROMPT_LIST_FAILED,
  FETCH_GENAI_PROMPT_LIST_PROGRESS,
  FETCH_GENAI_PROMPT_LIST_SUCCESS,
  FETCH_GENAI_PROMPT_PROGRESS,
  FETCH_GENAI_PROMPT_SUCCESS,
  CLEAR_GENAI_CONTEXT,
  CLEAR_GENAI_CONTEXT_STATE,
  FETCH_GENAI_CONTEXT_FAILED,
  FETCH_GENAI_CONTEXT_LIST_FAILED,
  FETCH_GENAI_CONTEXT_LIST_PROGRESS,
  FETCH_GENAI_CONTEXT_LIST_SUCCESS,
  FETCH_GENAI_CONTEXT_PROGRESS,
  FETCH_GENAI_CONTEXT_SUCCESS,
} from "./genAiActions";

export const genAiReducer = (
  state: IStoreState["genAi"] = defaultGenAiState,
  action: GenAiActions,
) => {
  switch (action.type) {
    // ============ GenAI Prompt Cases ============
    case FETCH_GENAI_PROMPT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.prompt.list.loading = LoadState.InProgress;
        draftState.prompt.list.data = [];
        draftState.prompt.list.error = null;
      });
      return newState;
    }
    case FETCH_GENAI_PROMPT_LIST_SUCCESS: {
      const { data, totalRecords, currentRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.prompt.list.loading = LoadState.Loaded;
        draftState.prompt.list.data = data;
        draftState.prompt.list.currentRecords = currentRecords;
        draftState.prompt.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_GENAI_PROMPT_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.prompt.list.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_GENAI_PROMPT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.prompt.prompt.loading = LoadState.InProgress;
        draftState.prompt.prompt.data = defaultGenAiPrompt;
        draftState.prompt.prompt.error = null;
      });
      return newState;
    }
    case FETCH_GENAI_PROMPT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.prompt.prompt.loading = LoadState.Loaded;
        draftState.prompt.prompt.data = data;
      });
      return newState;
    }
    case FETCH_GENAI_PROMPT_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.prompt.prompt.loading = LoadState.Failed;
        draftState.prompt.prompt.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_GENAI_PROMPT: {
      const newState = produce(state, (draftState) => {
        draftState.prompt.prompt.loading = LoadState.NotLoaded;
        draftState.prompt.prompt.data = defaultGenAiPrompt;
        draftState.prompt.prompt.error = null;
      });
      return newState;
    }

    case CLEAR_GENAI_PROMPT_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.prompt = defaultGenAiState.prompt;
      });
      return newState;
    }

    // ============ GenAI Context Cases ============
    case FETCH_GENAI_CONTEXT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.context.list.loading = LoadState.InProgress;
        draftState.context.list.data = [];
        draftState.context.list.error = null;
      });
      return newState;
    }
    case FETCH_GENAI_CONTEXT_LIST_SUCCESS: {
      const { data, totalRecords, currentRecords } = action.payload;

      const newState = produce(state, (draftState) => {
        draftState.context.list.loading = LoadState.Loaded;
        draftState.context.list.data = data;
        draftState.context.list.currentRecords = currentRecords;
        draftState.context.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_GENAI_CONTEXT_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.context.list.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_GENAI_CONTEXT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.context.context.loading = LoadState.InProgress;
        draftState.context.context.data = defaultGenAiContext;
        draftState.context.context.error = null;
      });
      return newState;
    }
    case FETCH_GENAI_CONTEXT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.context.context.loading = LoadState.Loaded;
        draftState.context.context.data = data;
      });
      return newState;
    }
    case FETCH_GENAI_CONTEXT_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.context.context.loading = LoadState.Failed;
        draftState.context.context.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_GENAI_CONTEXT: {
      const newState = produce(state, (draftState) => {
        draftState.context.context.loading = LoadState.NotLoaded;
        draftState.context.context.data = defaultGenAiContext;
        draftState.context.context.error = null;
      });
      return newState;
    }

    case CLEAR_GENAI_CONTEXT_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.context = defaultGenAiState.context;
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
